import { IPaymentMethodLookupWithRequisiteType } from '../../Requisites/core/response.types'
import { RequisiteEdit } from '../../../core/_models'
import { isWalletOnly } from './isWalletOnly'

/**
 * У реквизита кошелька нет карты и банка, держатель необязателен: пустые поля уходят как null,
 * а не пустой строкой — пустая строка для сервера это «неверный номер карты».
 */
export const clearWalletFields = <T extends Partial<RequisiteEdit>>(
  query: T,
  lookup: IPaymentMethodLookupWithRequisiteType[]
): T => {
  if (!isWalletOnly(query.paymentMethods, lookup)) return query

  return {
    ...query,
    cardNumber: null,
    acquiringBank: null,
    cardholderName: query.cardholderName?.trim() ? query.cardholderName : null,
  }
}
